import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { timeStringFormatShortForm } from '@/common/lib/timer';
import { type Reward } from '@/common/types/earnRewardsType';
import { H3 } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';

import styles from './styles.module.scss';

interface ClaimRewardButtonProps {
  seconds: number;
  isLoading: boolean;
  onClick: () => void;
  activeReward?: Reward;
}

const ClaimRewardButton: FC<ClaimRewardButtonProps> = ({
  seconds,
  isLoading,
  onClick,
  activeReward,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonBlock}>
      {!seconds ? (
        <MainButton
          onClick={onClick}
          isLoading={isLoading}
          text={t('Claim')}
          className="!w-full"
        />
      ) : (
        <div className="bg-white/10 rounded-lg p-2 flex items-center justify-center relative h-12 overflow-hidden">
          <H3 className="text-white font-extrabold">
            {t('Claim in')} {timeStringFormatShortForm(seconds * 1000)}
          </H3>
          <div
            className={styles.progressBar}
            style={{
              width: `${100 - (seconds / ((activeReward?.intervalHours ?? 24) * 60 * 60)) * 100}%`,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ClaimRewardButton;
